<template>
  <span
    v-if="value !== undefined && value != null"
    v-b-tooltip :title="tooltip"
    :class="'badge badge-' + variant"
    style="cursor: pointer;"
    @click="$emit('click')">
    {{ value }}
    <i
      class="fa fa-fw fa-times"
      v-if="deletable"
      @click.prevent.stop="remove()"></i>
  </span>
</template>
<script>
export default {
  props: {
    askBeforeRemoving: {
      type: Boolean,
      default: false
    },

    tooltip: {
      type: String,
      default: undefined
    },

    deletable: {
      type: Boolean,
      default: false,
    },

    value: {
      type: String,
      default: undefined
    },

    variant: {
      type: String,
      default: 'primary'
    }
  },

  methods: {
    remove() {
      if (!this.askBeforeRemoving || confirm('Vuoi veramente rimuovere il tag?')) {
        this.$emit('remove');
      }
    }
  }
};
</script>
